import React from 'react'

import ErrorPage from '~/components/ErrorPage'

const Unexpected = () => <ErrorPage heading="Something went wrong" message="Try refreshing the page" />

Unexpected.displayName = 'Unexpected'

export default Unexpected
